import React, { PureComponent } from 'react'
import styled from 'styled-components'

const StyledHint = styled.div`
  color: #999;
  background: rgba(0, 0, 0, 0.1);
  align-items: center;
  text-align: center;
  padding: 12px;
  border-radius: 3px;
  margin: 5px 0;
`

class ErrorBoundaryComponent extends PureComponent {
  constructor (props) {
    super(props)
    this.state = { hasError: false }
  }

  componentDidCatch () {
    this.setState({ hasError: true })
  }

  render () {
    if (this.state.hasError) {
      return (
        <StyledHint>
          Chyba při načítání
        </StyledHint>
      )
    }

    return React.cloneElement(this.props.children, this.props)
  }
}

export default ErrorBoundaryComponent
